import { FC, useMemo } from "react";
import { SchemaItemProps } from "@data-root/react";
import { RefSchemaItem } from "@data-root/types";
import { DetailItem } from "..";
import { RefDetailCarouselPresentation } from "./Carousel";
import { RefDetailFormPresentation } from "./Deck";

export const RefDetailModalPresentation: FC<SchemaItemProps<RefSchemaItem>> = ({
  item,
}) => {
  return <DetailItem item={item} />;
};

export const RefDetail: FC<SchemaItemProps<RefSchemaItem>> = (props) => {
  const { item } = props;
  const { presentation: _presentation } = item;

  const presentation = useMemo(() => _presentation || "Modal", [_presentation]);

  switch (presentation) {
    case "Carousel":
      return <RefDetailCarouselPresentation {...props} />;
    case "Deck":
    case "Form":
      return <RefDetailFormPresentation {...props} />;
    case "Modal":
    default:
      return <RefDetailModalPresentation {...props} />;
  }
};
